import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'default' | 'large';
  onClick?: () => void;
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'default',
  onClick,
  className = ''
}: ButtonProps) {
  const baseStyles = 'font-semibold rounded-lg transition-all duration-300 cursor-pointer inline-block text-center';
  const variantStyles = {
    primary: 'bg-gold-400 hover:bg-gold-500 text-slate-900 shadow-lg hover:shadow-xl',
    secondary: 'bg-teal-600 hover:bg-teal-500 text-white shadow-lg hover:shadow-xl'
  };
  const sizeStyles = {
    default: 'px-8 py-3 text-base',
    large: 'px-12 py-4 text-lg md:text-xl'
  };
  return <motion.button onClick={onClick} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} animate={{
    boxShadow: ['0 0 20px rgba(251, 191, 36, 0.5)', '0 0 30px rgba(251, 191, 36, 0.8)', '0 0 20px rgba(251, 191, 36, 0.5)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} data-id="element-19">
      {children}
    </motion.button>;
}